// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ZZCY","requiredAsterisk":"Info_requiredAsterisk__3o1n_"};